import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import {ColleagueShort, User} from '../../../types/users';
import Temp from '../../../assets/profile.svg';
import { useOnClickOutside } from '../../../hooks/useOutsideClick';

interface Props { }

export type ColleaguePopupAvatarListHandle = {
    show: (x: number, y: number, users: Array<User>) => void;
};

export const ColleaguePopupAvatarList = forwardRef<ColleaguePopupAvatarListHandle,
        Props>(({}: Props, ref) => {
    const [popupVisible, setPopupVisible] = useState<boolean>(false);
    const [colleagues, setColleagues] = useState<Array<User>>();
    const [x, setX] = useState(0);
    const [y, setY] = useState(0);

    useImperativeHandle(ref, () => ({
        show(x: number, y: number, users: Array<User>) {
            setX(x);
            setY(y);
            setColleagues(users);
            togglePopupVisibility();
        }
    }));

    const togglePopupVisibility = () => {
        setPopupVisible(!popupVisible);
    }
    const closePopup = () => {
        setPopupVisible(false);
    }

    const wrapperRef = useRef(null);
    useOnClickOutside(wrapperRef, closePopup);


    return (
        <div
            ref={wrapperRef}
        >
            {popupVisible ?
                <div
                    className={`absolute flex flex-col overflow-hidden z-50 bg-white rounded-lg shadow-below 
                        p-4 w-[361px]`}
                    style={{
                        left: x,
                        top: y,
                    }}
                >
                    <div className='text-[18px]'>Пассажиры</div>
                    <div className='flex flex-col gap-5 mt-5'>
                        {colleagues?.map((participant: User, index) => {
                            // Todo: extract component
                            return <div key={index} className='flex'>
                                <img
                                    className='rounded-full flex-[0_0_auto] mr-3 h-[44px] w-[44px] object-cover'
                                    src={participant.photo_img?.file ?? Temp}
                                    alt='profile'
                                />
                                <div className='flex flex-col text-base overflow-hidden text-[12px] leading-[14px]
                                        py-[2px]'>
                                    <div className='grow'>
                                        {participant.first_name} {participant.last_name}
                                        {/*{user.pk === profile?.pk ?*/}
                                        {/*    <img className='ml-2 my-auto h-4 w-4' src={Plane} alt='plane'/>*/}
                                        {/*    :*/}
                                        {/*    <></>*/}
                                        {/*}*/}
                                    </div>
                                    <div
                                        className='text-melon-grey-darker'
                                    >
                                        {participant.post}
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
                :
                <></>
            }
        </div>
    );
});
